import React, { useState, useRef, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'

import { toast } from 'react-toastify'

import api from 'api/api'
import './informacionPublica.css'
import { debounce } from 'utils/debounce'
import Paginacion from 'components/Paginacion'
import NuevaInformacionPublica from './NuevaInformacionPublica'
import VerInformacionPublica from './VerInformaionPublica'
import EditarInformacionPublica from './EditarInformacionPublica'
import DeleteInformacionPublica from './DeleteInformacionPublica'
import { getFileData } from 'utils/general'



function InformacionPublica() {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(10)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [informaciones, setInformaciones] = useState([])
	const [actual, setActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')

	const refresh = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('a/ver-informaciones-publicas', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					nombre: [filtroBusqueda]
				}
			})

			setInformaciones(datos.informaciones)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refresh()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refresh()
		}
	}, [paginaAct])

	const opcionesCuantosMostrar = [10, 25, 50]

	const handleAction = (informacion, cual) => {
		setActual(informacion, setQueMostrar(cual))
	}

	const guardarDatosNuevo = async (data) => {
        setLoading(true)
		try {
			const { msg } = await api.post('a/informaciones-publicas', data)
			refresh()
			setQueMostrar('')
			toast.success(msg)            
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		} finally {
            setLoading(false)
        }
	}

	const guardarDatosEdicion = async (data) => {
        setLoading(true)
		try {
			const { msg } = await api.put('a/informaciones-publicas/' + data.id, data)
			refresh()
			setQueMostrar('')
			toast.success(msg)

            if (data.files && data.files.length > 0) {
                subirDocumento(data.files)
            }
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		} finally {
            setLoading(false)
        }
	}

    const guardar = (data) => {
        if (data.files && data.files.length > 0) {
            subirDocumento(data)
        } else {
            delete data.files
            if (data.id) {
                guardarDatosEdicion(data)
            } else {
                guardarDatosNuevo(data)
            }           
        }
    }

	const eliminar = async (id) => {
		const { msg } = await api.delete('a/informaciones-publicas/' + id)
		refresh()
		setQueMostrar('')
		toast.success(msg)
	}

    const subirDocumento = async (data) => {
        setLoading(true)
        let documentoData = new FormData()
        documentoData.append('documento', data.files[0])
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            //cancelToken: cancelToken.token
        }
        try {
            const { datos: respuesta, msg, error } = await api.post('a/documentos', documentoData, config)

            if (!error) {
                console.info('Documento guardado exitosamente', respuesta)
                delete data.files
                data.documentoId = respuesta.id
                if (data.id) {
                    guardarDatosEdicion(data)
                } else {
                    guardarDatosNuevo(data)
                }
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
	}


	// render
	return (
		<Container fluid id="informacion-publica" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group className="mb-3" style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">documentos</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="d-flex no-gutters justify-content-between align-items-end mt-2">
				<Col>
					<Button onClick={() => setQueMostrar('nuevo')} variant="primary">
						<i className="fa fa-plus"></i> Nueva información pública
					</Button>
				</Col>
				<Col className="text-end">
					<small>Total resultados: <strong>{numResultados}</strong></small>
				</Col>
			</Row>
			{/* Table */}
			<Row>
				<Col>
					<Table id="tabla-informacionPublica" className="mt-2" bordered hover>
						<thead>
							<tr>
								<th>Id</th>
                                <th>Documento</th>
								<th>Nombre</th>
								<th>Grupo</th>
								<th>Orden</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan="6">
										<Spinner
											animation="border"
											size="lg"
											role="status"
											aria-hidden="true"
											variant="primary"
											className="my-3"
										/>
									</td>
								</tr>
							) : (
								informaciones.length === 0 ? (
									<tr>
										<td colSpan="6">
											<Alert variant="info">No se encontró información pública</Alert>
										</td>
									</tr>
								) : (
									informaciones.map((informacion, index) => {
										const fileData = getFileData(informacion.documento?.url)

										return (
											<tr key={informacion.id}>
												<td>{informacion.id}</td>
                                                <td><i className={fileData.icono}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + informacion.documento?.url}>{fileData.nombre}</a></td>
												<td>{informacion.nombre}</td>
												<td>{informacion.grupo}</td>
												<td>{informacion.orden || '-'}</td>
												<td>
													<Button
														onClick={() => handleAction(informacion, 'ver')}
														className="me-2"
														variant="primary"
													>
														<i className="fa fa-eye"></i>
													</Button>
													<Button
														onClick={() => handleAction(informacion, 'editar')}
														className="me-2"
														variant="secondary"
													>
														<i className="fa fa-pencil"></i>
													</Button>
													<Button
														onClick={() => handleAction(informacion, 'eliminar')}
														variant="danger"
													>
														<i className="fa fa-trash"></i>
													</Button>
												</td>
											</tr>
										)
									})
								)
							)}
						</tbody>
					</Table>
				</Col>
			</Row>
			<Row>
				<Col>
					<Paginacion
						pagina={paginaAct}
						numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
						setPagina={setPaginaAct}
					/>
				</Col>
			</Row>
			{/* Panel Nuevo */}
			{queMostrar === 'nuevo' && (
				<NuevaInformacionPublica
					guardar={guardar}
					setQueMostrar={setQueMostrar}
				/>
			)}
			{/* Panel Ver */}
			{actual && queMostrar === 'ver' &&
				<VerInformacionPublica
					informacion={actual}
					setQueMostrar={setQueMostrar}
				/>
			}
			{/* Panel Editar */}
			{actual && queMostrar === 'editar' &&
				<EditarInformacionPublica
					informacionOriginal={actual}
					setQueMostrar={setQueMostrar}
					guardar={guardar}
				/>
			}
			{/* Modal Delete */}
			{
				actual &&
				<DeleteInformacionPublica
					informacion={actual}
					mostrar={queMostrar === 'eliminar'}
					setQueMostrar={setQueMostrar}
					eliminarInformacion={eliminar}
				/>
			}
		</Container>
	)
}

export default InformacionPublica